import request from '@/utils/request'
const platform = localStorage.getItem('platform')

export function getMediaAdvertiserStats(data) {
    let url = `/${platform}/media_advertiser_stats/advertiser`
    return request.get(url, data)
}

export function getMediaWorkerStats(data) {
    let url = `/${platform}/media_advertiser_stats/worker`
    return request.get(url, data)
}

export function getMediaCampaignStats(data) {
    let url = `/${platform}/media_advertiser_stats/campaign`
    return request.get(url, data)
}

export function getRecentMediaCampaigns(data) {
    let url = `/${platform}/media_advertiser_stats/campaigns`
    return request.get(url, data)
}

export function closeCampaigns(data) {
    let url = `/${platform}/media_advertiser_stats/campaign/close`
    return request.post(url, data)
}

export function enableCampaigns(data) {
    let url = `/${platform}/media_advertiser_stats/campaign/enable`
    return request.post(url, data)
}

export function getAdvertiserCampaignsCount(data) {
    let url = `/${platform}/open/advertiser_campaigns_count`
    return request.get(url, data)
}

export function closeAllAdvertiserCampaigns(data) {
    let url = `/${platform}/media_advertiser_stats/advertiser/close_all_campaigns`
    return request.post(url, data)
}

export function enableAllAdvertiserCampaigns(data) {
    let url = `/${platform}/media_advertiser_stats/advertiser/enable_all_campaigns`
    return request.post(url, data)
}
